import React from 'react';

import styled, { css } from 'styled-components';

import { useProductBrowser } from '@techstyle/react-components';
import { FormattedMessage } from '@techstyle/react-intl';

import { mobile } from '../../styles';

interface Props {
  isMobileAndVariant?: boolean;
}

const CountContainer = styled.div<Props>`
  ${props => props.theme.subHeader.variants.subHeading4Uppercase.textStyles};
  font-weight: 400;
  span {
    color: ${props => props.theme.colors.black};
  }
  ${props =>
    props.isMobileAndVariant &&
    css`
      ${mobile`
        padding-left: ${props => props.theme.spacing.small}px;

        color: ${props => props.theme.colors.gray500}
      `}
    `}
`;

export const ProductGridCount: React.FC<Props> = ({
  isMobileAndVariant = false,
}) => {
  const { totalCount } = useProductBrowser();

  return (
    <CountContainer isMobileAndVariant={isMobileAndVariant}>
      <FormattedMessage
        id="site_product_grid.product_count"
        defaultMessage="{count} {count, plural, one {Product} other {Products}}"
        values={{ count: totalCount }}
      />
    </CountContainer>
  );
};
